import * as React from 'react';

type ILikeProps = React.SVGProps<SVGSVGElement>;

export function Like(props: ILikeProps) {
  return (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
      <g fill="none" fillRule="evenodd">
        <path
          stroke="#2B87DB"
          strokeWidth="1.273"
          d="M.636 12.364H1.91V5.836H.636v6.528zM8.86 1.488a4.27 4.27 0 0 0-.113-.139.86.86 0 0 0-.186-.166l-.107-.088L8.31.947l-3.574 4.26-.28-.02V11.7c0 .367.29.664.636.664h5.727c.236 0 .5-.137.731-.367l1.805-4.301a3.448 3.448 0 0 1 .004-.412c.004-.068.005-.088.005-.113V5.85c0-.367-.29-.664-.636-.664H8.136l.724-3.698z"
        />
        <path fill="#D8D8D8" fillOpacity="0" d="M0 0h14v14H0z" />
      </g>
    </svg>
  );
}
